import './assets/main.scss';
import 'ckeditor5/ckeditor5.css';
import { getRecaptchaSettings } from './api/index';
import { install } from 'vue3-recaptcha-v2';

import CKEditor from '@ckeditor/ckeditor5-vue';

import { createApp } from 'vue';
import App from './App.vue';

const app = createApp(App);

getRecaptchaSettings().then((settings) => {
  app.use(install, {
    sitekey: settings.reCaptchaKeys.site_key,
  });

  app.use(CKEditor).mount('#share-story-app');
});
